export const servicesData = {
  'legal-advisory': {
    title: 'Legal & Advisory Solutions',
    subtitle: 'Strategic | Practical | Result-Driven',
    contact: '8976587979',
    content: `Comprehensive legal and advisory solutions tailored to resolve complex disputes and protect your interests. Our strategic and result-driven approach ensures the best possible outcomes in litigation, negotiations, and property matters.`,
    icon: 'Scale',
    features: [
      {
        title: 'Litigation & Dispute Resolution (Civil & Criminal)',
        description: 'Proactive and aggressive representation for complex civil disputes and criminal defense matters. We specialize in dismantling the opposing narrative to secure your freedom and economic interests seamlessly across every tier of the judicial system.'
      },
      {
        title: 'Labour & Employment Counsel',
        description: 'Shielding enterprises from damaging worker disputes and ensuring absolute compliance with Indian labor codes. We draft foolproof employment contracts, handle HR policy structuring, and defend against wrongful termination claims.'
      },
      {
        title: 'Family & Personal Counsel',
        description: 'High-stakes personal dispute resolution managed with profound empathy and unshakeable discretion. We handle contested divorces, custody battles, and delicate family settlements to protect your peace and assets.'
      },
      {
        title: 'Intellectual Property Protection (IPR)',
        description: 'Fiercely defending your brand, patents, and creative assets from infringement. We manage trademark registration, copyright filings, and aggressive litigation against counterfeiters to preserve your market dominance.'
      },
      {
        title: 'Contract Drafting, Vetting & Negotiation',
        description: 'Engineering watertight agreements that preempt litigation. We meticulously draft, review, and negotiate high-value commercial contracts, NDAs, and vendor agreements to ensure you never leave money or leverage on the table.'
      },
      {
        title: 'Conveyancing, Stamp Duty & Registration Compliance',
        description: 'Executing flawless property transactions with zero bureaucratic delays. We handle the labyrinth of stamp duty adjudication, registration procedures, and local authority compliance so your acquisitions are legally indisputable.'
      },
      {
        title: 'Property Documentation & Title Regularization',
        description: 'Securing land titles and untangling complex ownership histories. We perform exhaustive due diligence, title searches, and regularization of disputed titles to eliminate risk for buyers and developers.'
      },
      {
        title: 'Estate Planning, Wills & Succession Advisory',
        description: 'Securing generational wealth transfers unconditionally. We structure ironclad wills, family trusts, and probate execution to ensure your legacy passes seamlessly without provoking destructive family litigation.'
      },
      {
        title: 'Liasoning & Legal Support',
        description: 'Navigating local governmental bodies, regulatory agencies, and municipal corporations on your behalf. We cut through red tape to secure necessary approvals, licenses, and permits efficiently.'
      },
      {
        title: 'Dispute Strategy & Pre-Litigation Advisory',
        description: 'Neutralizing legal threats before they reach the courtroom. We analyze your risk exposure, issue strategic legal notices, and facilitate mediation to resolve conflicts privately and cost-effectively.'
      }
    ]
  },
  'taxation-compliance': {
    title: 'Taxation & Compliance Services',
    subtitle: 'Accurate | Compliant | Insight-Driven',
    contact: '8879647979',
    content: `Engineered to keep your enterprise structurally sound and legally compliant. We handle everything from detailed audits and restructuring to comprehensive taxation strategies and regulatory appeals on a global scale.`,
    icon: 'Landmark',
    features: [
      {
        title: 'Comprehensive Direct & Indirect Taxation',
        description: 'Strategic tax planning and strict adherence to corporate and individual tax liabilities. We optimize your tax posture, minimizing exposure while safeguarding compliance against aggressive governmental audits.'
      },
      {
        title: 'International Taxation',
        description: 'Mastering the intricacies of cross-border tax liabilities. We navigate Double Taxation Avoidance Agreements (DTAA), transfer pricing, and global tax structuring to legally minimize international tax friction.'
      },
      {
        title: 'GST Governance & Compliance',
        description: 'End-to-end GST support, from complex input tax credit optimizations to handling departmental scrutiny. We establish robust governance structures to ensure zero non-compliance penalties.'
      },
      {
        title: 'ROC & Company Compliance',
        description: 'Managing seamless compliance with the Ministry of Corporate Affairs. Handling annual returns, board resolutions, directorial changes, and statutory filings to protect corporate governance.'
      },
      {
        title: 'Accounts & Financial Management',
        description: 'Installing rigorous financial frameworks. We provide detailed oversight on accounting procedures, cash flow tracking, and financial reporting crucial for scaling and sustaining investor confidence.'
      },
      {
        title: 'RERA Registration & Compliance',
        description: 'Navigating real estate regulations seamlessly. We assist developers with RERA project registrations, quarterly compliances, and defending against homebuyer complaints at the Tribunal.'
      },
      {
        title: 'Forensic Audit & Investigations',
        description: 'Uncovering financial irregularities and corporate fraud. Our forensic specialists surgically analyze financial records to expose embezzlement, asset misappropriation, and white-collar crime within your entity.'
      },
      {
        title: 'Foreign Tax, NRI Tax & 15CA/CB Certification, Cross-Border Transaction Structuring',
        description: 'Specialized counsel for Non-Resident Indians handling repatriation and cross-border investments. We issue 15CA/CB certifications and orchestrate capital routing for maximum tax efficiency.'
      },
      {
        title: 'FEMA / Fera Compliance',
        description: 'Acting as your impenetrable shield against Enforcement Directorate investigations. We ensure all FDI, outbound investments, and structural transactions comply strictly with foreign exchange management regulations.'
      },
      {
        title: 'PMLA Advisory & Compliance',
        description: 'Pre-emptive compliance and aggressive defense in Prevention of Money Laundering Act matters. We establish fail-safe KYC/AML protocols and heavily defend clients against ED asset attachment orders.'
      },
      {
        title: 'International Remittance Advisory',
        description: 'Ensuring your global capital moves swiftly and legally. We resolve Reserve Bank of India queries and author opinions on complex inward and outward foreign remittances.'
      },
      {
        title: 'Scutiny, Appeals & Tribunal Counsel',
        description: 'Taking the fight to appellate authorities on unfair tax demands. We represent clients aggressively before ITAT, CESTAT, and High Courts to squash unlawful assessments and regulatory overreach.'
      }
    ]
  },
  'finance-advisory': {
    title: 'Lending, Investment & Finance Advisory',
    subtitle: 'Structured | Secure | Growth-Oriented',
    contact: '8097247979',
    content: `Empowering both emerging startups and entrenched businesses with robust financial advice. From debt consolidation to insolvency rescue, our growth-oriented strategies secure your financial foundation.`,
    icon: 'TrendingUp',
    features: [
      {
        title: 'Start-up & Emerging Business Advisory',
        description: 'Architecting the legal foundation for rapid growth. We structure capital raises, term sheets, cap table management, and founder agreements so your startup remains attractive to institutional investors.'
      },
      {
        title: 'Finance & Debt Recovery Counsel',
        description: 'Aggressive recovery strategies for bad loans and delayed payments. We enforce commercial claims, invoke MSME Samadhaan, and execute swift recovery suits against defaulting debtors.'
      },
      {
        title: 'Asset Reconstruction & Debt Recovery (DRT / NCLT)',
        description: 'Specialist representation before Debt Recovery Tribunals and the NCLT. We assist banks alongside corporate debtors in resolving paralyzing NPAs and structuring asset takeovers legally.'
      },
      {
        title: 'Debt Structuring & Consolidation',
        description: 'Providing a lifeline during liquidity crunches. We negotiate master restructuring agreements with consortiums of banks, preventing destructive asset classification downgrades for distressed companies.'
      },
      {
        title: 'Corporate Rescue & Insolvency Counsel',
        description: 'Masterfully navigating the Insolvency and Bankruptcy Code (IBC). We formulate highly complex resolution plans for distressed companies to successfully avert liquidation and emerge revitalized.'
      }
    ]
  }
};
